import React, { useEffect, useState } from "react";
import styles from "./index.module.css";

import { Section } from "shared/layout";
import Button from "shared/Button";

import AlertNotice from "shared/AlertNotice";
import { Danger } from "react-ikonate";

import TabActionBar from "shared/TabActionBar";

export default function AccessCodeModal({ onClose, accessCode }) {
  return (
    <div>
      <Section className={styles.section}>
        <TabActionBar>
          <header className={styles.tabActionBarHeader}>
            <h3>Access Code</h3>
            <div>
              &nbsp;
              <Button size="small" onClick={() => onClose()}>
                Close
              </Button>
            </div>
          </header>
        </TabActionBar>
      </Section>

      <Section>
        {accessCode === "NULL" && (
          <AlertNotice icon={<Danger />} title="Error">
            <div className={styles.mb1}>
              An Access Code has not been generated for this user. Please login
              to the Topics app to generate a code.
            </div>
          </AlertNotice>
        )}

        {accessCode?.startsWith("ERROR") && (
          <AlertNotice icon={<Danger />} title="Error">
            <div className={styles.mb1}>
              {accessCode.replace("ERROR:", "").trim() ||
                "An unexpected error occurred."}
            </div>
          </AlertNotice>
        )}

        {accessCode &&
          accessCode !== "NULL" &&
          !accessCode.startsWith("ERROR") && (
            <div>
              <div>Please enter this code to access Topics:</div>
              <div className={styles.accessCode}>{accessCode}</div>
            </div>
          )}
      </Section>
    </div>
  );
}
